// MUS-450 - the copy of the "Connect your MIDI keyboard" prompt.
//
// A USB keyboard closes the prompt by itself once it is plugged in. A Bluetooth keyboard
// that went away may not come back on its own, so in the app the copy says what does
// happen and names the button to tap, instead of promising the prompt closes by itself.

/** The Bluetooth button the prompt shows: none, "Connect Bluetooth keyboard" or "Reconnect <name>". */
export type MidiPromptBluetoothAction = 'none' | 'connect' | 'reconnect';

const NO_DEVICE = "We didn't detect a MIDI device.";

/**
 * What the Android prompt shows for the moment before it knows which Bluetooth button it
 * offers: true whatever the button turns out to be, and the start of every full message.
 */
export const MIDI_PROMPT_PLACEHOLDER = NO_DEVICE;
const USB_CONNECTS = 'Plug in or turn on your keyboard. A USB keyboard connects by itself';

export const midiPromptMessage = (
  isNativeApp: boolean,
  action: MidiPromptBluetoothAction,
): string => {
  if (!isNativeApp) {
    return `${NO_DEVICE} Plug in and turn on your keyboard. This message will close automatically once connected.`;
  }
  switch (action) {
    case 'reconnect':
      return `${NO_DEVICE} ${USB_CONNECTS}; a Bluetooth keyboard reconnects when it is back on, or tap Reconnect.`;
    case 'connect':
      return `${NO_DEVICE} ${USB_CONNECTS}; for a Bluetooth keyboard, tap Connect Bluetooth keyboard.`;
    case 'none':
      return `${NO_DEVICE} ${USB_CONNECTS}.`;
  }
};
